// extracted by mini-css-extract-plugin
module.exports = {"hero":"layout-module--hero--2KJTa","navigation":"layout-module--navigation--1T0zt","navlink":"layout-module--navlink--1E0ej","subscribeLink":"layout-module--subscribeLink--2qSx2"};